module.exports = __webpack_public_path__ + "static/nav-star-16776c2fad72e2905038b86e2b85e9fe.png";